var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup280(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.192,
    height: 72.489,
    viewBox: "0 0 76.192 72.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M-463.1,425.527c1.149-2.329,1.015-4.026-.409-5.394-1.6-1.534-3.277-1.629-5.6-.314-1.875-2.553-3.325-3.072-5.893-2.07-.095-.181-.2-.367-.291-.556a4.013,4.013,0,0,0-5.231-1.964.712.712,0,0,1-.961-.213c-.905-1.116-1.816-2.228-2.686-3.371a.755.755,0,0,1,.025-.7q4.464-6.326,8.974-12.62a.874.874,0,0,1,.508-.37,28.845,28.845,0,0,1,7.149.172c-.915.73-1.68,1.386-2.492,1.976a3.551,3.551,0,0,0-1.548,3.191c.049,1.811.007,3.625.014,5.438.006,1.6.927,2.318,2.463,1.925a7.269,7.269,0,0,0,5.494-5.124.872.872,0,0,1,1.043-.73c1.165.045,2.334.032,3.5,0a.852.852,0,0,1,.873.511,10.718,10.718,0,0,0,3.405,3.972,2.992,2.992,0,0,0,1.442.445c1.487.063,2.979.014,4.468.059a2.161,2.161,0,0,1,1.1.335q6.5,4.412,12.964,8.868a2.293,2.293,0,0,1,.789,3.393,2.338,2.338,0,0,1-3.42.394q-5.839-4.121-11.668-8.256c-.142-.1-.28-.207-.427-.3a1.119,1.119,0,0,0-1.592.186c-.36.5-.219,1.06.421,1.515,1.456,1.036,2.921,2.058,4.382,3.086,1.6,1.128,3.211,2.25,4.807,3.388a2.208,2.208,0,0,1,.935,2.413,2.14,2.14,0,0,1-1.7,1.684,2.4,2.4,0,0,1-2.083-.536q-4.145-2.971-8.3-5.929c-.081-.058-.159-.119-.241-.176-.675-.466-1.268-.438-1.638.075s-.23,1.1.428,1.578c1.046.756,2.1,1.5,3.148,2.253.926.667,1.862,1.322,2.761,2.024a2.135,2.135,0,0,1,.866,2.165,2.256,2.256,0,0,1-3.616,1.45c-1.968-1.342-3.9-2.732-5.849-4.106-.93-.657-1.525-.7-1.952-.138s-.2,1.138.727,1.794c.507.357,1.024.7,1.517,1.078a2.105,2.105,0,0,1,.485,3.024,2.155,2.155,0,0,1-2.989.4,1.4,1.4,0,0,1-.733-1.574,3.964,3.964,0,0,0-2.611-4.081C-462.59,425.708-462.844,425.621-463.1,425.527Z",
    transform: "translate(496.523 -360.008)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M-416.043,159.612c0-2.806.012-5.612-.011-8.417a.782.782,0,0,1,.571-.866c4.868-2.032,9.724-4.1,14.593-6.125a1.391,1.391,0,0,1,.969,0c4.9,2.036,9.777,4.1,14.67,6.145a.7.7,0,0,1,.489.774c-.013,5.587,0,11.174-.019,16.76a8.62,8.62,0,0,1-1.594,4.574,28.075,28.075,0,0,1-6.2,6.58,1.351,1.351,0,0,1-.757.2q-5.8.239-11.6.456a.27.27,0,0,0-.074.005c-1.572.528-2.727-.1-3.888-1.161a30.837,30.837,0,0,1-5.633-6.208,9.411,9.411,0,0,1-1.529-5.347C-415.994,164.529-416.043,162.07-416.043,159.612Zm15.649,13.9a11.032,11.032,0,0,0,11.039-11.091,11.05,11.05,0,0,0-11.089-11.047,11.06,11.06,0,0,0-11.007,11.057A11.056,11.056,0,0,0-400.394,173.514Z",
    transform: "translate(438.501 -144.119)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M-384.94,406.314c0-1.985-.024-3.92.025-5.854a1.444,1.444,0,0,1,.536-.908c1.472-1.218,2.936-2.454,4.5-3.551a4.307,4.307,0,0,1,1.97-.459,88.9,88.9,0,0,1,17.39-.054,11.047,11.047,0,0,0,1.7.139,2.464,2.464,0,0,1,2.327,1.344c2.674,3.851,5.413,7.657,8.154,11.461a.849.849,0,0,1,0,1.228c-.9,1.055-1.776,2.131-2.662,3.2-.346.417-.662.416-1.13.09q-5.134-3.565-10.318-7.058a2.628,2.628,0,0,0-1.292-.4c-1.512-.069-3.027-.085-4.541-.077a1.736,1.736,0,0,1-1.506-.649c-.825-1.108-1.67-2.209-2.385-3.387a1.65,1.65,0,0,0-1.587-.963c-1.812.03-3.624.008-5.437.011-1.128,0-1.385.219-1.588,1.322A5.415,5.415,0,0,1-384.94,406.314Z",
    transform: "translate(412.021 -357.691)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M-185.41,353.59l13.21,15.159-8.848,6-11.617-16.314Z",
    transform: "translate(248.393 -322.376)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M-553.434,353.578l7.255,4.838L-557.8,374.731l-8.848-5.994Z",
    transform: "translate(566.645 -322.366)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M-402.525,559.11a6.5,6.5,0,0,1,.56-1.1q1.724-2.24,3.506-4.436a1.935,1.935,0,0,1,2.837-.321,1.955,1.955,0,0,1,.4,2.832c-1.168,1.542-2.377,3.052-3.594,4.555a1.918,1.918,0,0,1-2.287.565A2.4,2.4,0,0,1-402.525,559.11Z",
    transform: "translate(426.981 -491.883)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M-429.384,544.041a6.383,6.383,0,0,1-.533,1.18c-.605.845-1.26,1.656-1.917,2.463a2.022,2.022,0,0,1-2.842.411,1.993,1.993,0,0,1-.424-2.887c.648-.876,1.331-1.727,2.026-2.566a1.876,1.876,0,0,1,2.21-.576A2.336,2.336,0,0,1-429.384,544.041Z",
    transform: "translate(455.073 -482.643)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M-365.093,599.65a3.707,3.707,0,0,1,1.79-2.38,1.77,1.77,0,0,1,2.086.172,1.973,1.973,0,0,1,.5,2.865,9.961,9.961,0,0,1-.841,1.037,1.916,1.916,0,0,1-2.164.523A2.212,2.212,0,0,1-365.093,599.65Z",
    transform: "translate(395.127 -529.517)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M-463.026,530.865a1.973,1.973,0,0,1-2.064-2.039,2.787,2.787,0,0,1,2.446-2.544,2.047,2.047,0,0,1,2.03,2.032A2.684,2.684,0,0,1-463.026,530.865Z",
    transform: "translate(480.223 -469.335)",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M-359.564,227.019a8.493,8.493,0,0,1-8.4-8.911,8.513,8.513,0,0,1,8.885-8.116,8.508,8.508,0,0,1,8.1,8.829A8.5,8.5,0,0,1-359.564,227.019Zm-1.407-6.208c-.628-.7-1.149-1.33-1.73-1.9a1.2,1.2,0,0,0-1.842,0,1.242,1.242,0,0,0,.077,1.8q1.269,1.312,2.583,2.579a1.229,1.229,0,0,0,1.859.054q3.347-3.29,6.639-6.636a1.215,1.215,0,0,0,0-1.8,1.239,1.239,0,0,0-1.8.043c-1.247,1.211-2.47,2.447-3.694,3.681C-359.541,219.3-360.182,219.989-360.971,220.811Z",
    transform: "translate(397.568 -200.174)",
    fill: "#7a7a7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup280);
export default __webpack_public_path__ + "static/media/Group 280.dfea06bfbc9e82132b7dff396fbce67e.svg";
export { ForwardRef as ReactComponent };